import { Image } from "antd";
import styled from "styled-components";

export const Images = styled(Image)`
	width: 100% !important;
	height: auto !important;
	object-fit: cover;
	${({ theme }) =>
    theme.media.tablet(
      `
				height: 180px !important;
      `,
    )}
		${({ theme }) =>
    theme.media.mobile(
      `
				height: 120px !important;
			`,
		)}
`;

export const StyledPaginationContainer = styled.div`
  width: 25%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.5vw;
  margin-bottom: 1.5vw;
`;

export const StyledPageBtn = styled.button`
  display: flex;
  color: white;
  font-size: 3vw;
  justify-content: center;
  align-items: center;
`

export const StyledPage = styled.div`
  font-family: 'Inter medium';
  color: white;
  font-size: 1vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;
